export default __webpack_public_path__ + "static/media/solana.030116ab.svg";